import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'bundles.seotitle',
    defaultMessage: 'PC Game Bundles, Book Bundles & Software Bundles',
  },
  socialTitle: {
    id: 'bundles.socialtitle',
    defaultMessage: 'All Bundles',
  },
  // desc: {
  //   id: 'bundles.seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  fullDesc: {
    id: 'bundles.fulldesc',
    // TODO Update this when Marketing have sent it
    defaultMessage: 'Looking to try awesome new games at prices you won’t believe? Fanatical’s bundles offer the deals for you! Featuring the biggest and best Steam bundles for PC, Mac and Linux, as well as VR, eBooks, Software and more, you’ll typically find savings of 95% or more! Want more control? Choose one of our Build your own Bundles and create an incredible collection of games that is unique to you. Or if you’re feeling lucky, find your new favorite game in our monthly mystery bundles, where you’ll find everything from top AAA to exciting indie titles.',
  },
  games_title: {
    id: 'bundles.games_seotitle',
    defaultMessage: 'Steam Game Bundles',
  },
  games_socialTitle: {
    id: 'bundles.games_socialtitle',
    defaultMessage: 'Bundles | Exclusive Steam Game Bundles',
  },
  // games_desc: {
  //   id: 'bundles.games_seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  games_fullDesc: {
    id: 'bundles.games_fulldesc',
    defaultMessage: 'If you’re looking for massive savings on Steam games, then you’ve come to the right place! Fanatical’s game bundles bring together the latest and greatest PC Steam games at prices you won’t find anywhere else. Our bundles are exclusive, limited-time collections of games at great prices - available only on Fanatical! We work directly with publishers and developers to curate unmissable offers for you.',
  },
  books_title: {
    id: 'bundles.books_seotitle',
    defaultMessage: 'Book Bundles',
  },
  books_socialTitle: {
    id: 'bundles.books_socialtitle',
    defaultMessage: 'Exclusive Book Bundles',
  },
  // books_desc: {
  //   id: 'bundles.ebooks_seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  books_fullDesc: {
    id: 'bundles.ebooks_fulldesc',
    defaultMessage: 'We’re Fanatical about books! Whether you’re looking to learn a new skill, expand your knowledge on topics you’re passionate about or looking to expand your comic book collection, we have the bundles for you! There is a huge range of eBook and eLearning bundles to choose from, covering subjects such as machine learning and data science to photography and design. We work directly with the publishers to create exclusive bundles just for you.',
  },
  software_title: {
    id: 'bundles.software_seotitle',
    defaultMessage: 'Software Bundles',
  },
  software_socialTitle: {
    id: 'bundles.software_socialtitle',
    defaultMessage: 'Exclusive Software Bundles',
  },
  // software_desc: {
  //   id: 'bundles.software_seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  software_fullDesc: {
    id: 'bundles.software_fulldesc',
    defaultMessage: 'Our hugely popular software bundles offer a wide range of options for every need. Whether you’re looking for new assets for game creation, audio files for your music projects or utilities to help your PC run more smoothly - we’ve got you covered! We work with a number of top software providers to deliver exclusive bundles with savings you won’t get anywhere else.',
  },
  comics_title: {
    id: 'bundles.comics_seotitle',
    defaultMessage: 'Digital Comics Bundles',
  },
  comics_socialTitle: {
    id: 'bundles.comics_socialtitle',
    defaultMessage: 'Exclusive Digital Comics Bundles',
  },
  // comics_desc: {
  //   id: 'bundles.comics_seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  comics_fullDesc: {
    id: 'bundles.comics_fulldesc',
    defaultMessage: 'Check out our collection of exclusive digital comic bundles',
  },
  audio_title: {
    id: 'bundles.audio_seotitle',
    defaultMessage: 'Audio Bundles',
  },
  audio_socialTitle: {
    id: 'bundles.audio_socialtitle',
    defaultMessage: 'Exclusive Audio Asset Bundles',
  },
  // audio_desc: {
  //   id: 'bundles.audio_seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  audio_fullDesc: {
    id: 'bundles.audio_fulldesc',
    defaultMessage: 'Our collection of audio products deliver great quality and variety at a huge saving, providing game designers, developers, content creators and streamers with a huge catalog of sound and music files, all of which are royalty free, to enable you to enhance your productions.  Our exclusive Fanatical audio bundles deliver all of this at a fantastic price.',
  },
  video_title: {
    id: 'bundles.video_seotitle',
    defaultMessage: 'Video Bundles',
  },
  video_socialTitle: {
    id: 'bundles.video_socialtitle',
    defaultMessage: 'Exclusive Video Asset Bundles',
  },
  // video_desc: {
  //   id: 'bundles.video_seodesc',
  //   defaultMessage: 'Give your Steam library a boost with the biggest and best game bundles around for PC, Mac, and Linux. Our bundles offer incredible value for money with huge savings of up to 99%.',
  // },
  video_fullDesc: {
    id: 'bundles.video_fulldesc',
    defaultMessage: 'Check out our collection of exclusive video bundles',
  },
  bundlefest_title: {
    id: 'bundles.bundlefest.title',
    defaultMessage: 'BundleFest 2022',
  },
  bundlefest_socialTitle: {
    id: 'bundles.bundlefest.socialTitle',
    defaultMessage: 'Bundlefest | Exclusive PC Steam Game Bundles & Software Bundles',
  },
  bundlefest_desc: {
    id: 'bundles.bundlefest.desc',
    defaultMessage: 'Amazing bundles launching over the week featuring iconic AAA franchises, top quality indie games and awesome savings on eBooks, software and more',
  },
  lastChanceToBuy: {
    id: 'bundles.lastChanceToBuy',
    defaultMessage: 'Last Chance to Buy',
  },
});
